import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IconButton = (props) => {
  const { onIcon, offIcon, value, onChange, tooltip, onColor } = props;

  const _onClickHandler = (event) => {
    event.stopPropagation();
    onChange && onChange({ value: !value });
  };

  const className = value === false ? 'icon-button off' : 'icon-button on';

  return (
    <div className={className} onClick={_onClickHandler} role='none' tabIndex='-1' onKeyUp={() => {}}>
      {value === false ? <FontAwesomeIcon icon={offIcon} color='#FFFFFF' /> : <FontAwesomeIcon icon={onIcon} color={onColor || '#FFFFFF'} />}
      {tooltip ? <span className='tooltip'>{tooltip}</span> : null}
    </div>
  );
};

export default IconButton;
